import { render, staticRenderFns } from "./PaginationSimple.vue?vue&type=template&id=b6739168&scoped=true&"
import script from "./PaginationSimple.vue?vue&type=script&lang=js&"
export * from "./PaginationSimple.vue?vue&type=script&lang=js&"
import style0 from "./PaginationSimple.vue?vue&type=style&index=0&id=b6739168&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6739168",
  null
  
)

export default component.exports